import {Component, Input, OnInit} from '@angular/core';
import {SectionModel} from '@app/models/section';
import Section = SectionModel.Section;

@Component({
  selector: 'app-section-view',
  templateUrl: './section-view.component.html',
  styleUrls: ['./section-view.component.css']
})
export class SectionViewComponent implements OnInit {

  @Input()
  section: Section;

  constructor() { }

  ngOnInit() {
  }

}
